<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="证件名称">
        <el-input v-model="queryInfo.name" clearable placeholder="请输入证件名称"></el-input>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="queryInfo.type" clearable filterable>
          <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="warning" @click="applicationNew">发起申请</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="query">
        <el-tab-pane label="我的申请" name="queryMine"></el-tab-pane>
        <!-- <el-tab-pane label="待我审批" name="queryMyAudit"></el-tab-pane> -->
        <el-tab-pane label="待我审批" name="queryMyAudit">
          <div slot="label">
            待我审批
                <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已审批" name="queryApproval"></el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
      <template #operate={row,index}>
        <el-button type="text" size="small" v-if="(row.paperType === '个人证件' || row.paperType ===  '营业执照（原件）' || row.paperType ===  '产证（原件）' || row.paperType ===  '法人身份证（原件）') && row.status === 1 " @click="exportDetails(row.id)" :loading="row.loading || false">导出审批单</el-button>
        <div v-else style="display: inline-block; margin-right: 10px;">
          <el-button type="text" size="small" v-if="row.status === 1 && activeName == 'queryMine'" @click="download(row,index)" :loading="row.loading || false">下载附件</el-button>
          <el-button type="text" size="small" v-if="row.status === 1 && userName == row.createUser && activeName == 'queryMine'" @click="assignDownLoad(row)">指定下载人</el-button>
        </div>
          <!--1. 我的申请 审核不通过 已拒绝  2. 新增提交暂存 -->
          <el-button type="text" size="small"
          v-if="row.status === 2 && activeName == 'queryMine' || row.status === 10 && activeName == 'queryMine'" @click="update(row)">修改</el-button>
        <!--1. 我的申请 待审核 -->
          <el-button type="text" size="small" @click="approval('approval', row.id)" v-if="row.status === 0 && activeName == 'queryMine'">催批</el-button>
        <el-button type="text" size="small"  @click="details(row)">查看详情</el-button>
      </template>
    </table-list>
    <!-- 详情 -->
    <apply-details ref="applyDetails" @addSuccess="query" :certificatesList="certificatesList"/>
    <setUser ref="setUser"></setUser>
    <download ref="Download"/>
  </div>
</template>

<script>
import { query } from '@/api/compPaper'
import TableList from '@/components/TableList.vue'
import ApplyDetails from './applyDetails.vue'
import Download from './download.vue'
import moment from 'moment'
import { queryMyAudit, listMineAndCanDownloaded, postImageMark, sendSmsAuditPersonAgain, listApplyAudited } from '@/api/compApplyPaper'
import { ApprovalStatus } from '@/utils/constants'
import setUser from './setUser.vue'

export default {
  data () {
    return {
      queryInfo: {
        name: '',
        type: ''
      },
      certificatesList: [],
      fileList: [],
      activeName: 'queryMine',
      typeList: ApprovalStatus,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      workNumber: 0,
      tableData: [],
      loading: false,
      userName: '',
      columnDefs: [
        { label: '证件名称', prop: 'paperName' },
        { label: '证件类型', prop: 'paperType' },
        { label: '申请人', prop: 'applyUser' },
        {
          label: '审核人',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }
        },
        {
          label: '审核状态',
          formatter: (row) => {
            let status = ApprovalStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '申请时间', prop: 'createTime' },
        { label: '失效时间', prop: 'disableTime' },
        { label: '操作', prop: 'operate', width: 240 }
      ]
    }
  },
  components: {
    TableList,
    setUser,
    Download,
    ApplyDetails
  },
  methods: {
    async exportDetails (id) {
      await this.getData()
      this.$refs.Download.getDetails(id)
    },
    assignDownLoad(row) {
      this.$refs.setUser.edit(row)
    },
    getCertificatesList () {
      query().then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.certificatesList = result.records
        console.log(this.certificatesList, 'this.certificatesList');
      })
    },
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      let query = this.activeName === 'queryMyAudit' ? queryMyAudit : this.activeName === 'queryMine' ? listMineAndCanDownloaded : listApplyAudited
      query({
        pageSize: this.pageSize,
        pageNum: this.page,
        status: this.queryInfo.type,
        paperName: this.queryInfo.name
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
        this.getNum()
      })
    },
    getNum() {
      queryMyAudit({
        pageNum: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.workNumber = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    async download (row, index) {
      this.$set(this.tableData[index], 'loading', true)
      if (!row.disableTime) return
      let date = moment(new Date()).diff(moment(row.disableTime), 'minutes')
      if (date > 0) {
        this.$set(this.tableData[index], 'loading', false)
        this.$confirm('申请已失效，下载失败', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let file = this.certificatesList.find((item) => item.paperName === row.paperName)
        console.log(file, 'file');
        if (!file) {
          this.$set(this.tableData[index], 'loading', false)
          return this.$message('未查询到相关证件')
        }
        let urlArr = []
        this.fileList = file.attchmentUrl.split(',')
        // /202306/D栋楼宇产证信息20230628161334081.pdf  从后端返回得code解析name
        let nameList = this.fileList.map(v => {
          let name = v.split('/')
          return name[name.length - 1]
        })
        console.log(nameList);
        this.fileList.forEach(item => {
          urlArr.push(
            postImageMark({
              content: `${row.purpose} - ${row.disableTime}`,
              filename: item,
              // row.filename || '/202208/20220830151921861.jpeg',
              fontSize: '50'
            })
          )
        });
        Promise.all(urlArr).then((bolbArr) => {
          bolbArr.forEach((res, index) => {
             let blob = new Blob([res.data], { type: res.data.type })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            // let format = this.fileList[index].split('.')
            link.download = `${nameList[index]}.${file.attchmentType === 'IMG' ? 'jpg' : 'pdf'}`
            link.click()
          })
          this.$set(this.tableData[index], 'loading', false)
        })
        // let res = await postImageMark({
        //   content: `${row.purpose} - ${row.disableTime}`,
        //   filename: file.attchmentUrl,
        //   // row.filename || '/202208/20220830151921861.jpeg',
        //   fontSize: '50'
        // })
        // let blob = new Blob([res.data], { type: res.data.type })
        // let link = document.createElement('a')
        // link.href = window.URL.createObjectURL(blob)
        // let format = file.attchmentUrl.split('.')
        // link.download = `${row.paperName}.${format[1]}`
        // link.click()
      }
    },
    details (row) {
      // 待确认 是编辑还是查看
      this.$refs.applyDetails.showDetails('see', row.id, this.activeName)
    },
    update (row) {
      this.$refs.applyDetails.showDetails('new', row.id, this.activeName)
    },
    application () {
      this.$refs.applyDetails.showDetails('new', '', this.activeName)
    },
    applicationNew () {
      this.$refs.applyDetails.showDetails('new', '', 'queryMine')
    },
    async approval(type = 'new', id = '') {
      this.$confirm('此操作将进行催批, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': id
        }
        let res = await sendSmsAuditPersonAgain(params)
        if (res.code === 0) {
          this.$message({ type: 'success', message: '催批成功!' })
        }
        await this.getData()
      })
    },
  },
  mounted () {
    this.userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName || ''
    this.getCertificatesList()
    this.query()
  }
}
</script>

<style lang="scss" scoped>

</style>
